import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Login } from "./pages/LoginPage/Login";
import { Catalog } from "./pages/CatalogPage/Catalog";
import { Player } from "./pages/PlayerPage/Player";
import { Quiz } from "./pages/QuizPage/Quiz";
import { AdminDashboard } from "./pages/AdminDashboard/AdminDashboard";
import { QuizResult } from "./pages/QuizResult/QuizResult";
import { CreateUser } from "./pages/UserPage/UserCreate";
import { CreateBranch } from "./pages/BranchPage/BranchCreate";
import { CreateResponsibleArea } from "./pages/AreaPage/ResponsibleAreaCreate";
import { CreateCourse } from "./pages/CoursePage/CourseCreate";
import { CreateVideo } from "./pages/VideoPage/VideoCreate";
import { CreateQuiz } from "./pages/AddQuiz/CreateQuiz";
import { ChanegePassword } from "./pages/ChangePassword/ChangePassword";
import NotFound from "./pages/Erro404/NotFound";
import CourseDetail from "./pages/CourseDetail/CourseDetail";
import { ChanegeEmail } from "./pages/ChangeEmail/ChangeEmail";

    const AppRoutes = () => (
        <BrowserRouter>
            <Routes>
                <Route path="/login"  element={<Login/>}/>
                <Route path="/admin"  element={<AdminDashboard />} />
                <Route path="/" element={<Catalog />} />
                <Route path="/catalogo" element={<Catalog />} />
                <Route path="/player/:courseId" element={<Player />} />
                <Route path="/quiz/:quizId"  element={<Quiz />} />
                <Route path="/quiz/:quizId/resultado" element={<QuizResult />} />
                <Route path="/atualizar-senha" element={<ChanegePassword />}/>
                <Route path="/atualizar-email" element={<ChanegeEmail />}/>
                <Route path="/admin/create-user" element={< CreateUser/>} />
                <Route path="/admin/create-branch" element={< CreateBranch/>} />
                <Route path="/admin/create-responsilbe-area" element={< CreateResponsibleArea/>} />
                <Route path="/admin/create-course" element={< CreateCourse/>} />
                <Route path="/admin/create-video" element={< CreateVideo/>} />
                <Route path="/admin/create-quiz" element={< CreateQuiz/>} />
                <Route path="admin/course-details/:courseId" element={< CourseDetail />}/>

                {/* Rota para páginas inexistentes */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
)
export default AppRoutes